import React from 'react'

import AboutPage from '../../javascript/components/pages/AboutPage'

import { createRoot } from 'react-dom/client'

const codename = 'about-page'

// find mounting point in the DOM
const root = createRoot(document.querySelector(`#mount-${codename}-here`))

// render the component
root.render(
  <React.StrictMode>
    <AboutPage />
  </React.StrictMode>
)

